import { createStyles } from '@/contexts/theme-context';
import { Switch } from '@/components/switch';
import { TouchableOpacity, View } from 'react-native';
import { TrackingData } from '@/utils/analytics/base-reporter';
import { Typography } from '@usepepper/ui/atoms/typography';

interface ToggleSettingProps {
  icon: React.ReactNode;
  onClick?: () => void;
  onToggleChange: (value: boolean) => void;
  subtitle?: string;
  title: string;
  toggleTestID?: string;
  trackingData: TrackingData;
  value: boolean;
}

export const ToggleSetting: React.FC<ToggleSettingProps> = ({
  icon,
  onToggleChange,
  title,
  subtitle,
  trackingData,
  value,
  onClick,
  toggleTestID,
}) => {
  const [styles, theme] = useStyles();
  const isDisabled = !onClick;

  return (
    <TouchableOpacity
      disabled={isDisabled}
      onPress={onClick}
      style={[styles.row, styles.rowItem]}
    >
      <View style={[styles.row, styles.rowLabel]}>
        <View style={styles.rowItemIcon}>{icon}</View>
        <View collapsable={false} style={!subtitle ? styles.titleAlign : null}>
          <Typography color={theme.sk.color.text.primary} variant="heading-md">
            {title}
          </Typography>
          {subtitle ? (
            <Typography
              color={theme.sk.color.text.tertiary}
              variant="paragraph-sm"
            >
              {subtitle}
            </Typography>
          ) : null}
        </View>
      </View>

      <View style={styles.switch}>
        <Switch
          activeTrackColor={theme.sk.color.bg.toggle.on.default}
          onValueChange={onToggleChange}
          testID={toggleTestID}
          trackingData={trackingData}
          value={value}
        />
      </View>
    </TouchableOpacity>
  );
};

const useStyles = createStyles((theme) => ({
  row: {
    flexDirection: 'row',
  },
  rowItem: {
    justifyContent: 'space-between',
  },
  rowItemIcon: {
    alignItems: 'center',
    backgroundColor: theme.sk.color.bg.tertiary.default,
    borderRadius: 20,
    height: 40,
    justifyContent: 'center',
    width: 40,
  },
  rowLabel: {
    gap: 16,
  },
  switch: {
    marginTop: 4,
  },
  titleAlign: {
    marginTop: 4,
  },
}));
